import React, { SFC } from 'react'
import { Field, FieldRenderProps } from 'react-final-form'
import { isFunction } from '../index'

type Props = {
  name: string
  render(error: string): JSX.Element
}

export const Error: SFC<Props> = ({ name, render }) => {
  return <Field name={name} subscription={{ touched: true, error: true }} render={renderChildren} />

  function renderChildren({ meta: { touched, error } }: FieldRenderProps) {
    const content = isFunction(render) ? render(String(error)) : <span>{error}</span>

    return touched && error ? { content } : null
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/form-utils/field-error.tsx